import MediaUnits from '~/services/content/media_units';

export default {

    isInMillimeters(state, getters, rootState) {
        return (rootState.media.media.dimensions.unit == MediaUnits.MILLIMETERS);
    },

    saveData(state, getters, rootState) {
        return Object.assign(state.formData, {
            status: rootState.media.media.status
        });
    },

    getCloneMediaObjectById(state, getters, rootState) {
        return rootState.media.search.data.find(item => {
            return item.media_id === state.cloneMediaObjectId
        });
    },

    showCanvas(state) {
        return state.hasSectionContainer && state.hasPage;
    }
}